export const environment = {
  production: false,
  name: 'uat',
  apiBaseUrl: 'https://uatapispares.prajoshpureair.com/api/v1',
  defaultLocale: 'en-IN',
  currency: 'INR'
};
